import React from 'react';
import { policeDateInput } from '../utils/date';
import BaseDateField from './BaseDateField';

const DateField = props => {
  return <BaseDateField {...props} validationFn={policeDateInput} />;
};

export default DateField;
